const defaultDomain =
  window.location.hostname.indexOf('rastargame.com') >= 0 ? 'rastargame.com' : window.location.hostname;
class CookieManager {
  /**
   * 设置Cookie
   * @param name Cookie的名称
   * @param value Cookie的值
   * @param days Cookie的有效期天数，如果设置为0，则视为永久保存
   * @param domain 设置Cookie的域，默认为当前文档位置的路径的域部分
   */
  public setCookie(name: string, value: string, days: number, domain: string = defaultDomain): void {
    const encodedName = encodeURIComponent(name);
    const encodedValue = encodeURIComponent(value);
    let expires = '';

    if (days === 0) {
      const date = new Date();
      date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000); // 10 years
      expires = '; expires=' + date.toUTCString();
    } else if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    const domainPart = domain ? '; domain=' + domain : '';
    document.cookie = encodedName + '=' + encodedValue + expires + domainPart + '; path=/';
  }

  /**
   * 获取Cookie
   * @param name 要获取的Cookie名称
   * @returns 返回Cookie的值，如果不存在则返回空字符串
   */
  public getCookie(name: string): string {
    const encodedName = encodeURIComponent(name) + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
      const c = ca[i].trim();
      if (c.indexOf(encodedName) === 0) return decodeURIComponent(c.substring(encodedName.length, c.length));
    }

    return '';
  }

  /**
   * 删除Cookie
   * @param name 要删除的Cookie的名称
   * @param domain Cookie的域，如果指定，则只会删除该域下的同名Cookie
   */
  public deleteCookie(name: string, domain?: string): void {
    const domainPart = domain ? '; domain=' + domain : '';
    document.cookie = encodeURIComponent(name) + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + domainPart + '; path=/';
  }
}
export default new CookieManager();
